<template>
  <div>
    <v-field :class="getValidationClass('name')">
      <label>Ime skupine</label>
      <v-input v-model="form.name" />
      <span class="md-error" v-if="!$v.form.name.required">Vpišite ime skupine</span>
    </v-field>

    <v-field>
      <label for="accountMembershipIds">Uporabniki</label>
      <r-searchable-select v-model="form.accountMembershipIds" :options="users.map(user => ({ value: user.id, label: user.fullName }))" />
    </v-field>
  </div>
</template>

<script>
import { isEmpty } from 'lodash-es'
import { required } from 'vuelidate/lib/validators'
import ValidationMixin from '@/components/shared/ValidationMixin'
import VField from 'design-system/VField.vue'
import VInput from 'design-system/VInput.vue'
import RSearchableSelect from 'design-system/components/RSearchableSelect.vue'

export default {
  components: {
    VField,
    VInput,
    RSearchableSelect,
  },
  data () {
    return {
      form: {
        name: null,
        accountMembershipIds: [],
      },
    }
  },
  props: {
    userGroup: { type: Object, required: true },
    users: { type: Array, required: true },
  },
  mixins: [ValidationMixin],
  created () {
    if (isEmpty(this.userGroup)) {
      return
    }

    this.form.name = this.userGroup.name
    this.form.accountMembershipIds = this.userGroup.accountMemberships.map(am => am.id)
  },
  watch: {
    form: {
      handler (newFormValue) {
        this.$emit('change', {
          ...this.userGroup,
          ...newFormValue,
        })
      },
      deep: true,
    },
  },
  methods: {
    runAllValidations () {
      this.$v.$touch()
    },
    isValid () {
      return !this.$v.$invalid
    },
  },
  validations: {
    form: {
      name: {
        required,
      },
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/components/common';
</style>
